import { createTheme } from "@mantine/core";
import type { MantineColorsTuple } from "@mantine/core";

// Custom color palette for License Management System
const primaryColor: MantineColorsTuple = [
	"#f0f9ff",
	"#e0f2fe",
	"#bae6fd",
	"#7dd3fc",
	"#38bdf8",
	"#0ea5e9",
	"#0284c7",
	"#0369a1",
	"#075985",
	"#0c4a6e",
];

export const theme = createTheme({
	primaryColor: "blue",
	colors: {
		primary: primaryColor,
	},
	fontFamily:
		'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
	headings: {
		fontFamily:
			'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
		fontWeight: "600",
	},
	defaultRadius: "md",
	components: {
		Button: {
			defaultProps: {
				radius: "md",
			},
		},
		Card: {
			defaultProps: {
				shadow: "sm",
				withBorder: true,
				radius: "md",
			},
		},
		Paper: {
			defaultProps: {
				shadow: "xs",
				withBorder: true,
				radius: "md",
			},
		},
		Input: {
			defaultProps: {
				radius: "md",
			},
		},
		TextInput: {
			defaultProps: {
				radius: "md",
			},
		},
		PasswordInput: {
			defaultProps: {
				radius: "md",
			},
		},
		Select: {
			defaultProps: {
				radius: "md",
			},
		},
		Badge: {
			defaultProps: {
				radius: "md",
			},
		},
	},
});
